export default __webpack_public_path__ + "static/media/Portada-3.aceb5ee3.jpg";